import { render, staticRenderFns } from "./TrainingExamSummary.vue?vue&type=template&id=220a0092"
import script from "./TrainingExamSummary.vue?vue&type=script&lang=js"
export * from "./TrainingExamSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports